import actions from './actions';
import reducer from './reducer';

export { actions, reducer as default };


// WEBPACK FOOTER //
// ./src/components/quotation/store/index.js